import { ItemsQuery } from '@/types/ItemsQuery';

export type { ItemsListMeta } from '@/components/itemsList/itemsList.types';

export const FILTER_TYPE = {
    USER_DEFINED: 'USER_DEFINED',
    DATA_MODEL_DEFINED: 'DATA_MODEL_DEFINED',
    PUBLISHED_TO: 'PUBLISHED_TO',
    COMPLIANT_ITEMS: 'COMPLIANT_ITEMS',
    NON_COMPLIANT_ITEMS: 'NON_COMPLIANT_ITEMS',
    VALIDATION_ERRORS: 'VALIDATION_ERRORS',
    REVIEW_ERRORS: 'REVIEW_ERRORS',
    VALIDATION_WARNINGS: 'VALIDATION_WARNINGS',
    REVIEW_WARNINGS: 'REVIEW_WARNINGS',
    BULK_SUBSCRIPTION: 'BULK_SUBSCRIPTION',
    CATEGORY: 'CATEGORY',
    BULK_SEARCH: 'BULK_SEARCH',
} as const;

export const FILTER_URL_KEYS = [
    'compliant',
    'errorKey',
    'warningKey',
    'reviewErrorKey',
    'reviewWarningKey',
    'publicationDestination',
    'reviewer',
    'reviewStatus',
    'bulkSubscriptionId',
    'category',
    'bulkSearchId',
    'tags',
    'taskId',
] as const;

export type FilterUrlKey = (typeof FILTER_URL_KEYS)[number];

/** Mirror of Angular `activeFilters` entries keyed by filter type. */
export interface BrowseActiveFilter {
    name: string;
    type: string;
    itemsQuery?: Partial<ItemsQuery>;
    id?: string;
    readOnly?: boolean;
    isPublic?: boolean;
    searchKey?: string;
    [key: string]: unknown;
}
